export default "__VITE_ASSET__C45u82LA__"